import { buildQueryString } from "../../../helpers/buildQueryString";
import { publicRequest } from "../../../requestMeth";

import {
  loadDemandedFailure,
  loadDemandedStart,
  loadDemandedSuccess,
} from "../../reducers/analysis/loadDemandedRedux";

const pad = (n) => (n < 10 ? `0${n}` : n);

const formatDate = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

const toValidDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

const buildLoadDemandedQuery = ({ branchId, startDate, endDate, version }) => {
  const startD = toValidDate(startDate);
  const endD = toValidDate(endDate);

  return buildQueryString({
    branchId,
    startDate: startD ? formatDate(startD) : undefined,
    endDate: endD ? formatDate(endD) : undefined,
    version: version || undefined,
  });
};

const buildEmptyLoadDemandedResponse = ({
  startDate,
  endDate,
  message = "No hay datos disponibles para la consulta.",
}) => {
  const startD = toValidDate(startDate);
  const endD = toValidDate(endDate);

  return {
    billing_period: {
      start: startD ? startD.toISOString() : null,
      end: endD ? endD.toISOString() : null,
      timezone: "America/Argentina/Buenos_Aires",
    },
    config: null,
    quality: null,
    audit: {
      top_intervals: [],
    },
    contracted_power: {
      source: "BILL",
      account_number: null,
      selected_bill_id: null,
      items: [],
      contracted_power_map: {},
    },
    result: {
      overall: {
        raw_max_demand: 0,
        measured_max_demand: 0,
        timestamp_of_max_utc: null,
        interval_energy: 0,
        excess_count: 0,
        excess_intervals: 0,
        excess_max_kw: 0,
        excess_hours_equivalent: 0,
        penalty_estimated: 0,
      },
      by_tou: {},
    },
    series: [],
    summary_cards: [],
    meta: {
      no_data: true,
      message,
    },
  };
};

const getBackendMessage = (error) =>
  error?.response?.data?.message || "Error al obtener carga demandada";

const isHandledFunctional404 = (error) => {
  const status = error?.response?.status;
  const message = getBackendMessage(error);

  if (status !== 404) return false;

  return [
    "No se encontraron datos de energía para el período especificado.",
    "No se encontró configuración activa de maximeter.",
    "No hay dispositivos activos en la sucursal.",
    "No se encontró proveedor/suministro activo para la sucursal.",
    "No se encontró AccountNumber asociado a la sucursal.",
  ].includes(message);
};

export const getLoadDemanded = async (
  dispatch,
  token,
  branchId,
  startDate,
  endDate,
  version,
) => {
  dispatch(loadDemandedStart());

  try {
    const query = buildLoadDemandedQuery({
      branchId,
      startDate,
      endDate,
      version,
    });

    const res = await publicRequest.get(`/analysis/carga-demandada?${query}`, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(loadDemandedSuccess(res.data));
    return res.data;
  } catch (error) {
    const backendMessage = getBackendMessage(error);

    if (isHandledFunctional404(error)) {
      const emptyData = buildEmptyLoadDemandedResponse({
        startDate,
        endDate,
        message: backendMessage,
      });

      dispatch(loadDemandedSuccess(emptyData));
      return emptyData;
    }

    dispatch(loadDemandedFailure(backendMessage));
    return null;
  }
};